export class TimePickerRanges {
    dueTimes = [
      '00:00', '00:15', '00:30', '00:45', '01:00', '01:15', '01:30', '01:45', '02:00', '02:15', '02:30', '02:45', '03:00', '03:15', '03:30', '03:45',
      '04:00', '04:15', '04:30', '04:45', '05:00', '05:15', '05:30', '05:45', '06:00', '06:15', '06:30', '06:45', '07:00', '07:15', '07:30', '07:45',
      '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45',
      '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45',
      '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45',
      '20:00', '20:15', '20:30', '20:45', '21:00', '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'
    ];
    durationHours = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    durationMinutes = ['00', '15', '30', '45'];
  }
  
export class TransferCaseInputCase {
    caseChannel:string;
    caseNumber: string;
    caseId: string;
    contact: Address;
    customer: Address;
    department: string;
    description: string;
    delivery: Address;
    disableNotifications: boolean;
    internalNote: string;
    invoice: Address;
    files: TransferCaseStatusDataFile[];
    fitter: string;
    requisitionNumber: string;
    responsible: string;
    title: string;
    transferId: string;
    transferType: string;
    caseType: string;
    reference: string;
}

class Address {
    id: string;
    name: string;
    address: string;
    zipCode: string;
    city: string;
    phone: string;
    mobile: string;
    email: string;
}

  export class TransferCaseData {
    caseId: string = null;
    integrationId: string = null;
    caseTypeId: string = null;
    customerGroupId: number = null;
    economySystemGroupId: number = null;
    minubaCaseType: string = null;
    foremanId: string = null;
    eOrderGroupId: string = null;
    eDimensionCarrierId: string = null;
    eDimensionDepartmentId: string = null;
    eDimensionPurposeId: string = null;
    ePriceGroupId: string = null;
    eProfitGroupId: string = null;
    eProjectType: string = null;
    parentCaseId: string = null;
    responsibleId: string = null;
    osDepartmentId: number = null;
    osStatus: number = null;
  }
  
  /**
   * Class: TransferCaseStatusData is the data sent with the acceptCaseTransfer function, to create a case in the system (accepting a partner case/offer or creating a case from email)
   */
  export class TransferCaseStatusData {
    title: string;
    description: string;
    customer: TransferCaseStatusDataCustomer;
    delivery: TransferCaseStatusDataAddress;
    contact: TransferCaseStatusDataAddress;
    responsibleId: string;
    requisitionNumber: string;
    disableNotifications: boolean;
    caseNumber: string;
    reference: string;
    caseTypeId: string;
    caseChannel: string;
    files: TransferCaseStatusDataFile[];
  }
  
  class TransferCaseStatusDataCustomer {
    customerId: string;
    customerName: string;
    customerAddress: string;
    customerZipCode: string;
    customerCity: string;
    customerTelephone: string;
    customerFax: string;
    customerEmail: string;
    customerMobile: string;
    invoiceName: string;
    invoiceAddress: string;
    invoiceZipCode: string;
    invoiceCity: string;
    invoiceTelephone: string;
    invoiceFax: string;
    invoiceEmail: string;
    invoiceMobile: string;
    cvr: string;
    ean: string;
    customerRemarks: string;
    customerAttention: string;
  }
  
  class TransferCaseStatusDataAddress {
    skip: boolean;
    name: string;
    address: string;
    zipCode: string;
    city: string;
    telephone: string;
    mobile: string;
    email: string;
    att: string;
    ean: string;
  }
  
  class TransferCaseStatusDataFile {
    fileId: string;
    fileAccessId: string;
    path: string;
  }
  
  export class PartnerTransferCase {
    id: string;
    caseId: string;
    fromCompany: string;
    customer: PartnerTransferCaseAddress;
    invoice: PartnerTransferCaseAddress;
    delivery: PartnerTransferCaseAddress;
    contact: PartnerTransferCaseAddress;
    title: string;
    requisitionNumber: string;
    reference: string;
    description: string;
    companyMessage: string;
    responsibleId: string;
    createdAt: string;
    files: PartnerTransferCaseFile[];
    isOfferRequest: boolean;
    orderNumber: string;
    transferTypeId: string
  }
  
  class PartnerTransferCaseAddress {
    name: string;
    address: string;
    zipCode: string;
    city: string;
    email: string;
    phone: string;
    mobile: string;
  }
  
  class PartnerTransferCaseFile {
    fileId: string;
    fileTypeId: string;
    extension: string;
    originalName: string;
  }

  /*
    External classes for object transmutation 
    CaseOverViewCase : Case in OutboxOverview
  */

export class CaseOverviewCase {
    activities: OverviewCaseActivity[];
    caseId: string;
    caseChannel: OverviewCaseCaseChannel;
    caseNumber: string;
    caseType: CaseType;
    createdAt: string;
    companyName: string;
    consecutivelyOfferNumber?:any;
    customer: Customer;
    deliveryAddress: Customer;
    departmentId: string;
    description: string;
    disableNotifications: string;
    doneBy: DoneBy[];
    externalId: string;
    files: string[];
    fitter: Fitter;
    isOfferRequest: any;
    internalNote: string;
    lastMessage: LastMessage;
    lastModified: string;
    origin: Origin;
    orderNumber: string;
    offerNumber: number;
    partnerCases: PartnerCases[];
    propertyInfo: PropertyInfo;
    responsible: Responsible;
    requisitionNumber: string;
    startTime: string;
    status: CaseOverviewStatus;
    title: string;
    transferId: string;
    transferType: string;
    transferTypeId: string;
    unreadMessage: boolean;
    variationOrderNumber?: any
    vorRef: string;
}
    
export class Fitter {
    fitterId: string;
    name: string;
}
    
class Origin {
    originId: string;
    url: string;
    name: string;
}

class PartnerCases {
    caseId: string;
}

export class Responsible {
    responsibleId: string;
    name: string;
}

class CaseOverviewStatus {
    caseStatusId: string;
    name: string;
}

class CaseType {
    id: string;
    name: string;
}

class OverviewCaseCaseChannel {
    name: string;
    icon: string;
}

class PropertyInfo {
    propertyNumber: string;
    propertyLeaseNumber: string;
}

class LastMessage {
    case: string;
    seenAt: string;
    sentAt: string;
    sentBy: SentBy;
}

class SentBy {
    user: string;
    name: string;
}

class DoneBy {
    companyId: string;
    name: string;
}

export class Customer {
    address: string;
    externalId: string;
    customerNumber: string;
    customerId: string;
    name: string;
    city: string;
    zipCode: string;
    phone: string;
    email: string;
}

class OverviewCaseActivity {
    date: string;
    description: string;
}